var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module container-fluid"},[_c('ModuleTitle',{attrs:{"caption":_vm.item.title,"text":_vm.item.desc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }